import { render, staticRenderFns } from "./dynamic-model-edit.vue?vue&type=template&id=00099604&scoped=true"
import script from "./dynamic-model-edit.vue?vue&type=script&lang=js"
export * from "./dynamic-model-edit.vue?vue&type=script&lang=js"
import style0 from "./dynamic-model-edit.vue?vue&type=style&index=0&id=00099604&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../Desktop/Trabajo/gotrading/front/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00099604",
  null
  
)

export default component.exports